export const en = {
    BYN: 'BYN',
    CHF: '₣',
    EUR: '€',
    KZT: '₸',
    RUB: '₽',
    TRY: '₺',
    UAH: '₴',
    USD: '$',
    UZS: 'UZS',
    YND_FIXED: 'units'
};
